module.exports = __webpack_public_path__ + "media/images/ui__textCross--dark-32495326aef3f74e79e560e8d68e2eb1.png";